<template>
	<v-container
		fluid
	>
		<v-row>
			<v-col>
				<v-card>
					<v-card-title>
						<translate>Product Pricing Model Queries</translate>
					</v-card-title>
					<v-card-text>
						<v-row>
							<v-col>
								<h4>
									Device selection
								</h4>
								<device-search
									v-model="deviceId"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<h3><translate>Total Damage Claim Frequency (K)</translate></h3>
								<p>
									<translate>Damage claims frequency per policy day for the whole portfolio.</translate>
									<br>
								</p>
								<div class="align-center">
									<h2 v-if="queries.k != null">
										{{ queries.k }}
									</h2>
								</div>
							</v-col>
							<v-col>
								<h3><translate>Per Brand Damage Claim Frequency (Kb)</translate></h3>
								<p>
									<translate>Damage claims frequency per policy day per brand</translate>
									<br>
								</p>
								<div class="align-center">
									<h2 v-if="queries.kb != null">
										{{ queries.kb }}
									</h2>
								</div>
							</v-col>
							<v-col>
								<h3><translate>Per Series Damage Claim Frequency (Ks)</translate></h3>
								<p>
									<translate>Damage claims frequency per policy day per series</translate>
									<br>
								</p>
								<div class="align-center">
									<h2 v-if="queries.ks != null">
										{{ queries.ks }}
									</h2>
								</div>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									color="primary"
									block
									@click="query('k')"
								>
									Run Query
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									block
									@click="getReport('K')"
								>
									Download Report
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									color="primary"
									block
									@click="query('kb')"
								>
									Run Query
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									block
									@click="getReport('Kb')"
								>
									Download Report
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									color="primary"
									block
									@click="query('ks')"
								>
									Run Query
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									block
									@click="getReport('Ks')"
								>
									Download Report
								</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<h3><translate>Total Loss Claim Frequency (Lc)</translate></h3>
								<p>
									<translate>Loss claims frequency per policy day for the whole portfolio.</translate>
									<br>
								</p>
								<div class="align-center">
									<h2 v-if="queries.lc != null">
										{{ queries.lc }}
									</h2>
								</div>
							</v-col>
							<v-col>
								<h3><translate>Per Brand Loss Claim Frequency (Lcb)</translate></h3>
								<p>
									<translate>Loss claims frequency per policy day per brand</translate>
									<br>
								</p>
								<div class="align-center">
									<h2 v-if="queries.lcb != null">
										{{ queries.lcb }}
									</h2>
								</div>
							</v-col>
							<v-col>
								<h3><translate>Max Group Price (Mg)</translate></h3>
								<p>
									<translate>Return the max device price for certain groups</translate>
									<br>
								</p>
								<div class="align-center">
									<h2 v-if="queries.mg != null">
										{{ queries.mg }}
									</h2>
								</div>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									color="primary"
									block
									@click="query('lc')"
								>
									Run Query
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									block
									@click="getReport('Lc')"
								>
									Download Report
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									color="primary"
									block
									@click="query('lcb')"
								>
									Run Query
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									block
									@click="getReport('Lcb')"
								>
									Download Report
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:disabled="loading"
									:loading="loading"
									color="primary"
									block
									@click="query('mg')"
								>
									Run Query
								</v-btn>
							</v-col>
							<v-col>
								<v-btn
									:loading="loading"
									:disabled="loading"
									block
									@click="getReport('Mg')"
								>
									Download Report
								</v-btn>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DeviceSearch from '../../../molecules/DeviceSearch.vue';
import axios from 'axios';
import {
	displayError, inform,
} from 'laravel-front-library';
export default {
	name: 'ModelQueries',
	components: {
		DeviceSearch,
	},
	data () {
		return {
			deviceId: null,
			loading: false,
			queries: {
				k: null,
				kb: null,
				ks: null,
				lc: null,
				lcb: null,
				mg: null,
			},
		};
	},
	methods: {

		/** Error display helper functions */
		displayError,
		inform,

		/**
		 * Request query run on back-end and log the result
		 *
		 * @param {string} query Query and Endpoint name
		 * @returns {void}
		 */
		query (query) {
			if(this.deviceId != null) {
				this.loading = true;
				axios.get(`/bo/pricing/queries/${query}?device_id=${this.deviceId}`).then(({
					data,
				}) => {
					this.queries[query] = data[query];
				}).catch((error) => {
					this.displayError(error.response.data);
				}).finally(() => {
					this.loading = false;
				});
			} else {
				this.displayError('Please select a device!');
			}
		},

		/**
		 * Creates the date string for the filename like: YYYYMMDD
		 *
		 * @returns {string} The date string
		 */
		getDate () {
			const date = new Date();

			return `${date.getFullYear()}${('0' + (date.getMonth() + 1)).slice(-2)}${('0' + date.getDate()).slice(-2)}`;
		},

		/**
		 * Downloads the latest device report for the given query
		 *
		 * @param {string} query Query name
		 * @returns {void}
		 */
		getReport (query) {
			axios.get(`/bo/pricing/queries/report?query=${query}`).then((response) => {
				const fileURL = window.URL.createObjectURL(new Blob([response.data, ]));
				const fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', `pricing query ${query} ${this.getDate()}.csv`);
				document.body.appendChild(fileLink);

				fileLink.click();
			}).catch((error) => {
				this.displayError(error.response.data);
			});
		},
	},
};
</script>
